import { restClient } from '../config/restClient'

const endpoint = interviewRequestId => `/api/company/v2/interview_requests/${interviewRequestId}/messages`

export const getInterviewRequestsMessages = async (interviewRequestId, params) => {
  const response = await restClient(endpoint(interviewRequestId), {
    method: 'GET',
    params,
  })
  return response.data
}

export const postInterviewRequestMessage = async (interviewRequestId, data) => {
  const response = await restClient(endpoint(interviewRequestId), {
    method: 'POST',
    data,
  })
  return response.data
}

export const patchInterviewRequestMessage = async (interviewRequestId, messageId, data) => {
  const response = await restClient(`${endpoint(interviewRequestId)}/${messageId}`, {
    method: 'PATCH',
    data,
  })
  return response.data
}
